import { useSelector } from '../../../_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const driveTimePathsSelector = (state: AppState) => state.frontendState.proximityDriveTimePaths.paths;
export const useDriveTimePathsSelector = () => useSelector(driveTimePathsSelector);

const driveTimeMessagesSelector = (state: AppState) => state.frontendState.proximityDriveTimePaths.messages;
export const useDriveTimeMessagesSelector = () => useSelector(driveTimeMessagesSelector);
